import { Globe } from "lucide-react";
import type { DockKindDef } from "../../registry";
import { BrowserPanel } from "./BrowserPanel";
import { browserPanel } from "./data";

export { browserData, browserPanel, frameSrc, statusLabel, toViewportPoint, type BrowserData, type ScreenRow } from "./data";

/**
 * The browser kind (bots B2, 2026-09-03): an agent's screen in the dock —
 * watch it work, take it over, hand it back. It CAN be conjured from the
 * rail (`create`): the picker lists the open screens and opens a new one,
 * so the rail's long-standing "Browser (not built yet)" placeholder becomes
 * a real button. One panel per screen (stable id).
 */
export const browserKind: DockKindDef = {
	tabIcon: () => <Globe size={13} />,
	Body: BrowserPanel,
	create: () => browserPanel(""),
};
